<template>
  <v-container class="content-wrapper" fluid>
    <v-row v-if="!loading && patents.length == 0">
      <v-col cols="12">
        <v-btn
          v-show="isMarketplacePatents"
          depressed
          rounded
          small
          color="blue"
          class="white--text font-weight-bold"
          @click="goBack"
        >
          <v-icon color="black" small class="mr-2">
            mdi-arrow-left
          </v-icon>
          Back
        </v-btn>
      </v-col>
      <v-col cols="12">
        <p>
          No Patents found.
        </p>
      </v-col>
    </v-row>
    <v-row v-else class="mb-10 justify-start">
      <v-col
        cols="12"
        xl="4"
        lg="4"
        md="6"
        sm="6"
        xs="12"
        class="pa-3"
        v-for="(patent, index) in patents"
        :key="'patent-' + index"
      >
        <v-hover v-slot="{ hover }">
          <v-card
            class="d-flex flex-column"
            elevation="3"
            style="border-radius: 24px; height: 100%;"
            :class="{ 'on-hover': hover }"
            @click="handleCardClick(patent.id, $event)"
          >
            <div style="position: relative; width: 100%; text-align: center; overflow: hidden;">
              <v-app-bar
                flat
                class="custom-app-bar"
                style="position: absolute; top: 0; left: 0; width: 100%; z-index: 1; background: transparent;"
              >
                <v-chip flat label small color="blue" class="white--text font-weight-bold">
                  Patent
                </v-chip>
                <v-spacer></v-spacer>
                <v-btn
                  v-if="!patent.isFavorite && $store.getters.roles"
                  @click="addFavorite(patent)"
                  icon
                  raised
                  medium
                >
                  <v-icon>mdi-heart-outline</v-icon>
                </v-btn>
                <v-btn
                  v-if="patent.isFavorite && $store.getters.roles"
                  @click="removeFavorite(patent)"
                  icon
                  raised
                  medium
                  color="red"
                >
                  <v-icon>mdi-heart</v-icon>
                </v-btn>
              </v-app-bar>
              <div style="display: flex; justify-content: center; width: 100%; overflow: hidden;">
                <v-img
                  v-if="patent.logo"
                  height="200px"
                  max-width="100%"
                  v-bind:src="patent.logo"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
                <v-img
                  v-else
                  height="200px"
                  max-width="100%"
                  lazy-src="@/assets/img/blur.jpg"
                  :style="{ borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }"
                ></v-img>
              </div>
            </div>

            <v-card-text>
              <div class="text-start" align="start" justify="start">
                <v-col cols="12" class="black--text">
                  <b style="font-size: 20px;">{{ patent.title }}</b>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Provider</label>
                  <div v-if="$store.getters.roles">
                    <router-link
                      v-if="$route.fullPath.includes('search-marketplace')"
                      :to="{
                        name: 'OverviewProvider',
                        params: { id: patent.organisation.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          searchBar: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.organisation.name }}
                    </router-link>
                    <router-link
                      v-else
                      :to="{
                        name: 'OverviewProvider',
                        params: { id: patent.organisation.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          filters: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.organisation.name }}
                    </router-link>
                  </div>
                  <div v-else>
                    <router-link
                      v-if="$route.fullPath.includes('public-search-marketplace')"
                      :to="{
                        name: 'PublicOverviewProvider',
                        params: { id: patent.organisation.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          searchBar: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.organisation.name }}
                    </router-link>
                    <router-link
                      v-else
                      :to="{
                        name: 'PublicOverviewProvider',
                        params: { id: patent.organisation.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          filters: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.organisation.name }}
                    </router-link>
                  </div>
                </v-col>
              </div>
              <div class="text-start">
                <v-col cols="12">
                  <label class="primary200--text">Hosting Institution</label>
                  <div v-if="$store.getters.roles">
                    <router-link
                      v-if="$route.fullPath.includes('search-marketplace')"
                      :to="{
                        name: 'OverviewHostingInstitution',
                        params: { id: patent.hostingInstitution.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          searchBar: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.hostingInstitution.name }}
                    </router-link>
                    <router-link
                      v-else
                      :to="{
                        name: 'OverviewHostingInstitution',
                        params: { id: patent.hostingInstitution.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          filters: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.hostingInstitution.name }}
                    </router-link>
                  </div>
                  <div v-else>
                    <router-link
                      v-if="$route.fullPath.includes('public-search-marketplace')"
                      :to="{
                        name: 'PublicOverviewHostingInstitution',
                        params: { id: patent.hostingInstitution.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          searchBar: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.hostingInstitution.name }}
                    </router-link>
                    <router-link
                      v-else
                      :to="{
                        name: 'PublicOverviewHostingInstitution',
                        params: { id: patent.hostingInstitution.id },
                        query: {
                          marketplacePatentsViewAll: true,
                          filters: true,
                          ...getParams(),
                          ...localFilteredParams,
                        },
                      }"
                      style="text-decoration: underline; color: inherit;"
                    >
                      {{ patent.hostingInstitution.name }}
                    </router-link>
                  </div>
                </v-col>
              </div>
              <div v-if="patent.tags.length > 0">
                <v-chip
                  :color="color(index)"
                  v-for="(tag, index) in patent.tags"
                  :key="index"
                  class="ma-2"
                >
                  {{ tag }}
                </v-chip>
              </div>
            </v-card-text>

            <v-spacer></v-spacer>
            <v-divider class="custom-divider"></v-divider>

            <v-card-actions>
              <v-row align="center">
                <v-col class="d-flex align-center">
                  <v-btn @click="redirectToOverview(patent.id)" icon style="min-width: auto;">
                    <v-icon style="color: rgba(0, 0, 0, 0.87)!important;" class="mr-2">
                      mdi-arrow-top-right
                    </v-icon>
                  </v-btn>
                  <p class="mb-0">More Details</p>
                </v-col>
                <v-col class="d-flex justify-end" v-if="patent.email != null">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-if="!$store.getters.roles"
                        @click.stop="openLoginModal(patent.id)"
                        icon
                        v-bind="attrs"
                        v-on="on"
                        style="min-width: auto;"
                      >
                        <v-icon style="color: rgba(0, 0, 0, 0.87)!important;">
                          mdi-email-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Contact</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <!-- Pagination -->
    <v-row v-if="pagesLength > 1">
      <v-spacer></v-spacer>
      <v-col cols="4" md="2" class="justify-end d-flex flex-row align-center">
        <div>{{ totalItems }} Results</div>
      </v-col>
      <v-col cols="8" md="2" class="justify-end d-flex flex-row align-center">
        <div class="pr-2">Show:</div>
        <div style="max-width: 90px">
          <v-select
            v-model="options.itemsPerPage"
            :items="[10, 20, 30, 40, 50, { text: 'All', value: -1 }]"
            dense
            outlined
            hide-details
            @change="onItemsPerPageChange"
          ></v-select>
        </div>
      </v-col>
      <v-col cols="12" md="6" class="justify-end d-flex flex-row align-center">
        <v-pagination
          v-model="options.page"
          :length="pagesLength"
          :total-visible="7"
          @input="getFilteredDataFromApi"
        ></v-pagination>
      </v-col>
    </v-row>

    <!-- Non registered dialog -->
    <v-dialog v-model="modalLogIn" max-width="1000px" :retain-focus="false" hide-overlay>
      <v-card class="py-4 px-5 px-sm-16 px-md-16 px-lg-16 px-xl-16 py-sm-8 py-md-8 py-lg-8 py-xl-8">
        <v-card-title class="px-0 py-0">
          <v-row class="mx-0 px-2" align="center">
            <v-col cols="11" class="text-center d-flex justify-center align-center">
              This action requires authentication
            </v-col>
            <v-col cols="1" class="pl-0">
              <v-btn fab small text @click="modalLogIn = false">
                <v-icon color="neutral500">
                  mdi-close
                </v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider class="mt-1 mb-6 my-sm-6 my-lg-6 my-xl-6 my-md-6"></v-divider>
        <v-card-text class="pa-0 text-center">
          Only authenticated users are allowed to perform this action. Please
          <router-link :to="{ name: 'OverviewPatent', params: { id: selectedPatentId } }"
            ><span class="font-weight-bold">Log In</span></router-link
          >
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import EventBus from '@/helpers/event-bus.js';
import util from '@/mixins/util.js';

export default {
  name: 'MarketplacePatentsFilteredViewAll',
  mixins: [util],
  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      patents: [],
      totalItems: 0,
      pagesLength: null,
      loading: false,
      patent: {
        title: '',
        logo: '',
        organisation: {
          id: null,
          name: '',
        },
        hostingInstitution: {
          id: null,
          name: '',
        },
        tags: [],
      },
      currentSortParams: '',
      modalLogIn: false,
      selectedPatentId: '',
      localFilteredParams: {},
    };
  },
  props: {
    filteredParams: {
      type: Object,
    },
    sortParams: {
      type: String,
    },
    searchMarketplace: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    if (this.$route.query.filters === 'true') {
      const query = { ...this.$route.query };
      delete query.index;
      delete query.marketplacePatentsViewAll;
      delete query.selectedCatalogue;
      delete query.size;
      delete query.filters;
      if (query.applyForLicense !== undefined) {
        query.applyForLicense = query.applyForLicense === 'true';
      }
      this.localFilteredParams = query;
      console.log('Filters from URL:', this.localFilteredParams);
    } else {
      this.localFilteredParams = { ...this.filteredParams };
    }
    if (this.$route.query.index !== undefined) {
      const index = parseInt(this.$route.query.index);
      this.options.page = index + 1;
    }
    if (this.$route.query.size !== undefined) {
      this.options.itemsPerPage = parseInt(this.$route.query.size);
    }
    this.currentSortParams = this.sortParams || '';
  },
  mounted() {
    if (this.$route.query.fromTable) {
      this.options.page = 1;
    }
    this.getFilteredDataFromApi();
  },
  watch: {
    filteredParams: {
      deep: true,
      immediate: false,
      handler(newVal) {
        console.log('filteredParams changed:', newVal);
        this.localFilteredParams = { ...newVal };
        this.options.page = 1;
        this.getFilteredDataFromApi();
      },
    },
    sortParams: {
      deep: true,
      immediate: false,
      handler(newVal) {
        console.log('sortParams changed:', newVal);
        this.currentSortParams = newVal;
        this.getFilteredDataFromApi(newVal);
      },
    },
    '$route.query': {
      immediate: false,
      handler(query) {
        if (query.index !== undefined) {
          const index = parseInt(query.index);
          this.options.page = index + 1;
        }
        if (query.size !== undefined) {
          this.options.itemsPerPage = parseInt(query.size);
        }
      },
    },
  },
  computed: {
    isMarketplacePatents() {
      return (
        this.$route.path === '/marketplace/patents' ||
        this.$route.path === '/public-catalogue-marketplace/patents'
      );
    },
  },
  methods: {
    getFilteredDataFromApi(sortParams = this.currentSortParams) {
      const paginationParams = this.getParams();

      const filteredParams = {
        ...paginationParams,
        ...this.localFilteredParams,
      };

      this.deleteEmptyProperties(filteredParams);

      console.log('Combined params for request:', filteredParams);

      this.loading = true;
      EventBus.$emit('waiting', true);

      this.axios
        .get(
          `/api/v1/patent?${new URLSearchParams(filteredParams)}${
            sortParams ? `&${sortParams}` : ''
          }`,
        )
        .then(response => {
          console.log('Get Filtered Data:', response.data);
          this.patents = response.data.content;
          this.totalItems = response.data.total;
          this.pagesLength = response.data.pagesLength;
        })
        .catch(error => {
          console.error('Error fetching patent:', error);
        })
        .finally(() => {
          this.loading = false;
          EventBus.$emit('waiting', false);
        });
    },
    deleteEmptyProperties(obj) {
      if (!obj || typeof obj !== 'object') {
        return;
      }

      if (Array.isArray(obj)) {
        obj.forEach((item, index) => {
          if (item === null || item === undefined || item === '') {
            obj.splice(index, 1);
          } else if (typeof item === 'object') {
            this.deleteEmptyProperties(item);
            if (Object.keys(item).length === 0) {
              obj.splice(index, 1);
            }
          }
        });
      } else {
        for (const key in obj) {
          if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
            delete obj[key];
          } else if (Array.isArray(obj[key])) {
            this.deleteEmptyProperties(obj[key]);
            if (obj[key].length === 0) {
              delete obj[key];
            }
          } else if (typeof obj[key] === 'object') {
            this.deleteEmptyProperties(obj[key]);
            if (Object.keys(obj[key]).length === 0) {
              delete obj[key];
            }
          }
        }
      }
    },
    onItemsPerPageChange() {
      this.options.page = 1;
      this.getFilteredDataFromApi();
    },
    getParams() {
      const { page, itemsPerPage } = this.options;
      const query = {
        index: itemsPerPage === -1 ? 0 : page - 1,
        size: itemsPerPage === -1 ? 1000 : itemsPerPage,
      };
      return query;
    },
    handleCardClick(patentId, event) {
      if (event.target.closest('a, button, .v-btn, .v-icon')) {
        return;
      }
      this.redirectToOverview(patentId);
    },
    redirectToOverview(patentId) {
      if (this.$store.getters.roles != null) {
        const marketplacePatentsViewAll = true;
        const patentSearchMarketplace = true;

        if (this.searchMarketplace) {
          this.$router.push({
            name: 'OverviewPatent',
            params: { id: patentId },
            query: {
              patentSearchMarketplace,
              filters: true,
              ...this.getParams(),
              text: this.$route.query.text,
            },
          });
        } else {
          this.$router.push({
            name: 'OverviewPatent',
            params: { id: patentId },
            query: {
              marketplacePatentsViewAll,
              filters: true,
              ...this.getParams(),
              ...this.localFilteredParams,
            },
          });
        }
      } else {
        const marketplacePatentsViewAll = true;
        const patentSearchMarketplace = true;

        if (this.searchMarketplace) {
          this.$router.push({
            name: 'PublicOverviewPatent',
            params: { id: patentId },
            query: {
              patentSearchMarketplace,
              filters: true,
              ...this.getParams(),
              text: this.$route.query.text,
            },
          });
        } else {
          this.$router.push({
            name: 'PublicOverviewPatent',
            params: { id: patentId },
            query: {
              marketplacePatentsViewAll,
              filters: true,
              ...this.getParams(),
              ...this.localFilteredParams,
            },
          });
        }
      }
    },
    addFavorite(patent) {
      const id = patent.id;
      EventBus.$emit('waiting', true);

      this.axios
        .post(`/api/v1/favorites-patents/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite added successfully',
          });
          this.getFilteredDataFromApi();
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    removeFavorite(patent) {
      const id = patent.id;
      EventBus.$emit('waiting', true);

      this.axios
        .delete(`/api/v1/favorites-patents/${id}`)
        .then(() => {
          EventBus.$emit('snackbar', {
            text: 'Favorite removed successfully',
          });
          this.getFilteredDataFromApi();
        })
        .catch(error => {
          EventBus.$emit('snackbar', {
            text: error.response.data,
            color: 'warning',
          });
        })
        .finally(() => {
          EventBus.$emit('waiting', false);
        });
    },
    goBack() {
      this.$emit('changeTab');
    },
    openLoginModal(patentId) {
      this.modalLogIn = true;
      this.selectedPatentId = patentId;
    },
  },
};
</script>

<style scoped>
.custom-divider {
  padding: 5px 0;
  margin: 0 35px;
  border-top-width: 2px;
  border-top-style: solid;
  border-top-color: rgba(195, 194, 199, 1);
}

.custom-app-bar {
  background-color: rgba(0, 0, 0, 0) !important;
  border-bottom: none !important;
}
</style>
